<template>
    <div v-if="plan">
        <card-header title="Plan Details" icon="fa-info-circle" />

        <card-body>
            <card-list>
                <subheader-list-item title="Client Information" icon="fa-user" />
            </card-list>
            <data-row title="Name">
                <div class="value">{{ plan.users.first_name }} {{ plan.users.last_name }}</div>
            </data-row>
            <data-row title="Email">
                <div class="value">{{ plan.users.email }}</div>
            </data-row>
            <data-row title="Alt Email" v-if="plan.users.email_2">
                <div class="value">{{ plan.users.email_2 }}</div>
            </data-row>
            <data-row title="Phone" v-if="plan.users.phone">
                <div class="value">{{ plan.users.phone }}</div>
            </data-row>
            <data-row title="Alt Phone" v-if="plan.users.phone_2">
                <div class="value">{{ plan.users.phone_2 }}</div>
            </data-row>

            <card-list>
                <subheader-list-item title="Plan Summary" icon="fa-align-left" />
            </card-list>
            <data-row title="Plan ID">
                <div class="value">R{{ plan.id }}</div>
            </data-row>
            <data-row title="Hours">
                <div class="value">{{ plan.hours }}</div>
            </data-row>
            <data-row title="Total">
                <div class="value">{{ plan.total | currency }}</div>
            </data-row>
            <data-row title="Monthly Payment">
                <div class="value">{{ plan.monthly | currency }}</div>
            </data-row>
            <data-row title="Term">
                <div class="value">{{ plan.term }} Month<span v-if="plan.term !== 1">s</span></div>
            </data-row>
            <data-row title="Deferment Date">
                <div class="value">{{ defer }}</div>
            </data-row>

            <card-list>
                <subheader-list-item title="Plan Status" icon="fa-list-check" />
            </card-list>
            <data-row title="Quote Submitted"><i class="fas fa-check"></i></data-row>
            <data-row title="Plan Created"><i class="fas fa-check"></i></data-row>
            <data-row title="TPO Onboarding"><i class="fas fa-check" v-if="plan.is_tpo_onboarded"></i><i class="fas fa-ban" v-else></i></data-row>
            <data-row title="Agreement"><i class="fas fa-ban"></i></data-row>
            <data-row title="Plan Activated"><i class="fas fa-ban"></i></data-row>

            <card-list v-if="!plan.is_tpo_onboarded">
                <subheader-list-item title="Resend Communications" icon="fa-paper-plane" />
                <container-list-item padded>
                    <div class="buttons">
                        <b-button
                            type="is-info"
                            expanded
                            @click="resendWelcomeEmail"
                            :loading="emailLoading"
                        >
                            <i class="fas fa-envelope mr-2"></i>Resend Welcome Email
                        </b-button>
                    </div>
                    <div class="buttons mt-3" v-if="plan.users.phone">
                        <b-button
                            type="is-info"
                            expanded
                            @click="sendOnboardingSms"
                            :loading="smsLoading"
                        >
                            <i class="fas fa-sms mr-2"></i>Resend Onboarding SMS to {{ plan.users.phone }}
                        </b-button>
                    </div>
                    <div class="notification is-warning is-light mt-4" v-if="!plan.users.phone">
                        <i class="fas fa-exclamation-triangle mr-2"></i>
                        SMS unavailable - No phone number on file
                    </div>
                    <div class="notification is-info is-light mt-4">
                        <i class="fas fa-info-circle mr-2"></i>
                        Client can also access their TPO Onboarding on the dashboard of their my247ed.com account. They can simply login to access it.
                    </div>
                </container-list-item>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import DataRow from "../../TIER/components/DataRow";

    import {client as http} from '../../http_client';
    import moment from "moment";

    export default {
        components: {DataRow, ContainerListItem, SubheaderListItem, CardList, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                plan: null,
                emailLoading: false,
                smsLoading: false
            };
        },
        computed: {
            defer() {
                return moment.utc(this.plan.defer_on).format('MMMM Do, YYYY');
            }
        },
        methods: {
            loadPlan: function () {
                this.$emit('loading', true);

                http.get('payment-plans/reseller/' + this.props.planId, {force: true}).then(response => {
                    this.plan = response.data;
                    this.$emit('loading', false);
                }).catch(err => {
                    console.log(err);
                    this.$emit('loading', false);
                    this.$buefy.toast.open({
                        message: 'Failed to load plan details. You may not have access to this plan.',
                        type: 'is-danger'
                    });
                });
            },
            resendWelcomeEmail: function () {
                const emailAddresses = this.plan.users.email_2
                    ? this.plan.users.email + ' and ' + this.plan.users.email_2
                    : this.plan.users.email;
                if (confirm('Are you sure you want to resend the welcome email to ' + emailAddresses + '?')) {
                    this.emailLoading = true;
                    http.post('payment-plans/' + this.plan.id + '/resend-welcome').then(response => {
                        this.emailLoading = false;
                        this.$buefy.toast.open({
                            message: 'Welcome email sent successfully!',
                            type: 'is-success'
                        });
                    }).catch(err => {
                        this.emailLoading = false;
                        this.$buefy.toast.open({
                            message: 'Failed to send welcome email',
                            type: 'is-danger'
                        });
                    });
                }
            },
            sendOnboardingSms: function () {
                if (confirm('Are you sure you want to send an onboarding SMS to ' + this.plan.users.phone + '?')) {
                    this.smsLoading = true;
                    http.post('payment-plans/' + this.plan.id + '/send-onboarding-sms').then(response => {
                        this.smsLoading = false;
                        this.$buefy.toast.open({
                            message: 'SMS sent successfully!',
                            type: 'is-success'
                        });
                    }).catch(err => {
                        this.smsLoading = false;
                        this.$buefy.toast.open({
                            message: 'Failed to send SMS',
                            type: 'is-danger'
                        });
                    });
                }
            }
        },
        watch: {
            'props.planId': function () {
                this.loadPlan();
            }
        },
        mounted() {
            this.loadPlan();
        }
    };
</script>

<style>
    .fa-check {
        color: green;
    }

    .fa-ban {
        color: red;
    }
</style>
